"use client"

import dynamic from "next/dynamic"
import IntersectionObserver from "./intersection-observer"
import {
  SocialLinksSkeleton,
  CharacteristicsSkeleton,
  BioSectionSkeleton,
  ServicesSkeleton,
  GallerySkeletonExact,
} from "./loading-skeletons"

// Lazy components with detailed skeletons
const ProfileGallery = dynamic(() => import("./profile-gallery"), {
  loading: () => <GallerySkeletonExact />,
  ssr: false,
})

const ProfileServices = dynamic(() => import("./profile-services"), {
  loading: () => <ServicesSkeleton />,
  ssr: false,
})

const SocialLinks = dynamic(() => import("./social-links"), {
  loading: () => <SocialLinksSkeleton />,
  ssr: true,
})

const ProfileCharacteristics = dynamic(() => import("./profile-characteristics"), {
  loading: () => <CharacteristicsSkeleton />,
  ssr: true,
})

const ProfileBioSection = dynamic(() => import("./profile-bio-section"), {
  loading: () => <BioSectionSkeleton />,
  ssr: true,
})

// Enhanced components with intersection observer
export function LazyGallery(props: any) {
  return (
    <IntersectionObserver placeholder={<GallerySkeletonExact />} rootMargin="200px">
      <ProfileGallery {...props} />
    </IntersectionObserver>
  )
}

export function LazyServices(props: any) {
  return (
    <IntersectionObserver placeholder={<ServicesSkeleton />} rootMargin="200px">
      <ProfileServices {...props} />
    </IntersectionObserver>
  )
}

export function LazySocialLinks(props: any) {
  return (
    <IntersectionObserver placeholder={<SocialLinksSkeleton />} rootMargin="200px">
      <SocialLinks {...props} />
    </IntersectionObserver>
  )
}

export function LazyCharacteristics(props: any) {
  return (
    <IntersectionObserver placeholder={<CharacteristicsSkeleton />} rootMargin="200px">
      <ProfileCharacteristics {...props} />
    </IntersectionObserver>
  )
}

export function LazyBioSection(props: any) {
  return (
    <IntersectionObserver placeholder={<BioSectionSkeleton />} rootMargin="200px">
      <ProfileBioSection {...props} />
    </IntersectionObserver>
  )
}
